/**
 * Bundled copies of the marketing repo's pack gating constants, for the
 * coverage matrix. Source of truth: intervyo-marketing lib/firms/pack-live.ts
 * and lib/firms/db-slug.ts. Snapshot dated 2026-08-19; the Packs page states
 * the date so drift is visible rather than silent.
 */
export const PACK_CONSTANTS_SNAPSHOT = '2026-08-19';

export const PACK_LIVE_UK = new Set([
  'goldman-sachs', 'jp-morgan', 'morgan-stanley', 'citi', 'bank-of-america',
  'barclays', 'deutsche-bank', 'ubs', 'hsbc', 'mckinsey', 'bcg', 'bain',
  'deloitte', 'pwc', 'ey', 'kpmg', 'clifford-chance', 'linklaters',
  'freshfields', 'ao-shearman', 'blackrock', 'blackstone', 'evercore',
  'standard-chartered',
]);

export const PACK_LIVE_US = new Set([
  'goldman-sachs', 'jp-morgan', 'morgan-stanley', 'citi', 'bank-of-america',
  'mckinsey', 'bcg', 'bain', 'deloitte', 'ey', 'kpmg', 'pwc', 'lazard',
  'evercore', 'centerview', 'blackstone', 'kkr',
  'sullivan-cromwell', 'skadden',
]);

/** Marketing slug to firms.slug. A missing entry for a differing pair means a sold pack that never grants. */
export const MARKETING_TO_DB_SLUG: Record<string, string> = {
  'jp-morgan': 'jpmorgan',
  'mckinsey': 'mckinsey-company',
  'bcg': 'boston-consulting-group',
  'bain': 'bain-company',
  'pwc': 'pwc-uk',
  'kpmg': 'kpmg-uk',
  'freshfields': 'freshfields-bruckhaus-deringer',
  'centerview': 'centerview-partners',
  'skadden': 'skadden-arps-slate-meagher-flom',
};

export const dbSlugFor = (marketingSlug: string): string =>
  MARKETING_TO_DB_SLUG[marketingSlug] ?? marketingSlug;
